import { SVGProps } from 'react';

interface Props {
  props?: SVGProps<SVGSVGElement>;
  size?: string | number;
  muted?: boolean;
}

const Delivery = ({ props, size = 16, muted = false }: Props) => {
  const dark = muted ? '#5d5d5d' : '#7c1c12';
  const light = muted ? '#6d6d6d' : '#fa541c';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path fill={dark} d="M0 0h16v16H0z" />
      <path
        fill={light}
        fillRule="evenodd"
        d="M6 0v2h6.586L0 14.586V16h1.414L14 3.415V10h2V1a1 1 0 0 0-1-1z"
        clipRule="evenodd"
      />
      <path fill={light} d="M15 0a1 1 0 0 1 1 1V0z" />
    </svg>
  );
};

export default Delivery;
